import { render, staticRenderFns } from "./RejectedResultCard.vue?vue&type=template&id=70050299"
import script from "./RejectedResultCard.vue?vue&type=script&lang=js"
export * from "./RejectedResultCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports